<template>
  <a :href="uri" class="flex flex-col items-center p-2 sm:p-4 relative border rounded bg-white" v-if="checkPrice">
    <template v-if="!loading">
      <ChristmasBadge v-if="canGetByChristmas" :time="canGetByChristmas" />
      <OutOfStockBadge v-else-if="outOfStock" />
      <VerifiedBadge v-else-if="verified" />
      <DeliveryBadge v-else-if="isLocal" />
    </template>
    <figure class="h-36 sm:h-56 flex flex-col justify-center">
      <img :src="thumbnail" :alt="product.title" class="max-h-36 sm:max-h-56" />
    </figure>
    <div class="w-full" :class="{ 'blur-sm': loading }">
      <span class="font-semibold text-sm">{{ product.brands[0] || '&nbsp;' }}</span>
      <div class="line-clamp-2" :title="product.title" v-html="product.title" />
    </div>
    <div v-if="product.priceInfo" :class="{ 'blur-sm': loading }" class="w-full flex flex-row items-center justify-between">
      <div class="text-brand font-bold">USD ${{ round(product.priceInfo.price) }}</div>
      <!-- <AAddToCart v-bind="{ product }" /> -->
    </div>
    <div :class="{ 'blur-sm': loading }" class="text-color-blue text-sm font-normal break-words w-full">
      {{ $t('taxesShipping') }}
    </div>
  </a>
</template>

<script>
import DeliveryBadge from './badges/DeliveryBadge.vue'
import VerifiedBadge from './badges/VerifiedBadge.vue'
import OutOfStockBadge from './badges/OutOfStockBadge.vue'
import ChristmasBadge from './badges/ChristmasBadge.vue'
// import AAddToCart from './AAddToCart.vue'
import placeholder from '@/assets/lazyloader.gif'
import christmasCutoffTimes from '@/assets/christmas-cutoff-times.json'
import { useSearchStore } from '@/stores/search'

export default {
  components: {
    DeliveryBadge,
    VerifiedBadge,
    OutOfStockBadge,
    ChristmasBadge,
    // AAddToCart,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    loading: Boolean,
  },
  data() {
    return {
      store: useSearchStore(),
    }
  },
  computed: {
    round: () => (number) => number ? Math.round(number * 100) / 100 : null,
    seller() {
      return String(this.product.attributes.seller?.text)
    },
    isLocal() {
      return this.seller.startsWith('Aeropost Local')
    },
    isAmazon() {
      return this.seller === 'AMAZON'
    },
    verified() {
      return !this.isLocal && !this.isAmazon
    },
    checkPrice() {
      return this.product.priceInfo.price > 0 ? true : false
    },
    outOfStock() {
      return this.product.availability !== 'IN_STOCK'
    },
    canGetByChristmas() {
      if (this.seller in christmasCutoffTimes) {
        const cutoff = new Date(christmasCutoffTimes[this.seller])

        return new Date().getTime() < cutoff.getTime() ? cutoff : false
      }

      return false
    },
    thumbnail() {
      if (this.loading) {
        return placeholder
      } else {
        return this.product.images[0]?.uri.replace('/upload', '/upload/d_no-image-small_tbhjva.gif/c_limit,h_332')
      }
    },
    uri() {
      return this.product.uri.replace('/BHS_en/', `/${this.store.gateway}_${this.store.locale}/`)
    },
  },
}
</script>
